module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "audio-player"
    }
  }, [_c('div', {
    staticClass: "icon-btn",
    class: {
      play: !_vm.isPlaying, pause: _vm.isPlaying
    },
    attrs: {
      "title": _vm.title
    },
    on: {
      "click": _vm.toggle
    }
  }), _c('input', {
    staticClass: "slider is-fullwidth is-small is-circle",
    attrs: {
      "type": "range",
      "step": "1",
      "min": "0",
      "max": _vm.durationMs,
      "disabled": _vm.isPlaying
    },
    domProps: {
      "value": _vm.currentTimeMs
    },
    on: {
      "input": _vm.updateTime
    }
  }), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.currentTimeMin))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6be80c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/AudioPlayer.vue
// module id = 427
// module chunks = 0